import {
  createNotificationAction,
  CreateNotificationActionParams,
} from '@/actions/notifications/create-notifications-action/index'
import { queryFactory } from '@/query-factory'
import { queries } from '@/shared/lib/tanstack-query/query-keys'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useCreateNotification = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationKey: ['notifications', 'create'],
    mutationFn: async (params: CreateNotificationActionParams) => {
      await createNotificationAction(params)
      return params
    },
    onSettled: (data) => {
      if (data) {
        queryClient.invalidateQueries({
          queryKey: [
            queries.products.notificationStatus(data.productId).queryKey,
          ],
        })
        queryClient.invalidateQueries({
          queryKey: queryFactory.notification.getNotifications.queryKey,
        })
      }
    },
  })
}
